import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            width: '100%',
            height: '100%',
            paddingTop: '50px',
            paddingRight: '40px',
            paddingBottom: '10px',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
        },
        body: {
            marginTop: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            '& .title': {
                marginBottom: 1
            }
        },
        nameContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        tabs: {
            minHeight: '50vh',
            padding: '24px 30px'
        },
        counter: (count: number) => ({
            minWidth: '180px',
            fontSize: '14px',
            color: count > 0 ? colors.color4 : colors.color13
        }),
        paper: {
            padding: '24px 16px',
            height: '558px'
        },
        containerButtons: {
            display: 'flex',
            alignItems: ' center',
            justifyContent: 'space-between'
        },
        containerTitle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        edit: {
            padding: 0,
            color: colors.color4,
        },
        delete: {
            padding: 0,
            color: colors.color19,
        },
        iconContainer:{
            display: 'flex',
            gap: 1,
            '& .MuiSvgIcon-root': {
                    fontSize: '36px'
                },
        }
    }
}

export { useStyles }
